/**
 * @fileoverview Web Push API functions
 * 
 * Handles Web Push subscription management for iOS Safari PWA
 * and other browsers that use standard Web Push API (not FCM).
 * 
 * @module api/web-push
 */

import apiClient from './client';

// ============================================================================
/**
 * Subscribe to Web Push notifications
 * @param {number} restaurantId - Restaurant ID
 * @param {PushSubscription} subscription - Push subscription object
 * @returns {Promise} Subscription response
 */
export const subscribeWebPush = async (restaurantId, subscription) => {
  try {
    const subscriptionJSON = subscription.toJSON();
    
    const payload = {
      restaurant_id: restaurantId,
      endpoint: subscriptionJSON.endpoint,
      p256dh_key: subscriptionJSON.keys.p256dh,
      auth_key: subscriptionJSON.keys.auth,
      user_agent: navigator.userAgent,
    };

    const response = await apiClient.post('/web-push/subscribe', payload);
    return response.data;
  } catch (error) {
    console.error('Error subscribing to Web Push:', error);
    throw error;
  }
};

/**
 * Unsubscribe from Web Push notifications
 * @param {string} endpoint - Push subscription endpoint
 * @returns {Promise} Unsubscribe response
 */
export const unsubscribeWebPush = async (endpoint) => {
  try {
    const response = await apiClient.delete('/web-push/unsubscribe', {
      params: { endpoint }
    });
    return response.data;
  } catch (error) {
    console.error('Error unsubscribing from Web Push:', error);
    throw error;
  }
};

/**
 * Convert a base64 string to Uint8Array (for VAPID key)
 * @param {string} base64String - Base64 encoded string
 * @returns {Uint8Array} Converted array
 */
export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};
